// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "cimt-3cbc5.firebaseapp.com",
  "projectId": "cimt-3cbc5",
  "storageBucket": "cimt-3cbc5.appspot.com",
  "messagingSenderId": "964785332471",
  "appId": "1:964785332471:web:cd1b5f3b62b05ba23533f2",
  "measurementId": "G-EDPV920QYV",
  "apiKey": "AIzaSyAtKCsXZyNp1MOSAYaT5Q_qh1b-q2RpAsU"
};
